import { useRootAppStore } from "@hooks";
import { useFixBody } from "@state/hooks/shared";
import { observer } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

export default observer(function BetBuilderPicksNotAvailablePopup() {
	const rootStore = useRootAppStore();
	const location = useLocation();
	const { t } = useTranslation();

	useFixBody(
		true,
		rootStore.quickPlayStore.betBuilderPicksStore.BBPickNotAvailablePopup
	);

	if (
		!location.pathname.includes("home") &&
		!location.pathname.includes("bet-builder-picks")
	) {
		rootStore.quickPlayStore.betBuilderPicksStore.setBBPicksAvailabilityPopup(
			false
		);
	}

	return (
		<div className="popup">
			<div className="popup__card popup__card--med">
				<div className="popup__header">
					{t("QUICK_PLAY.BET_BUILDER_PICKS.CATEGORY_TITLE")}
				</div>
				<div className="popup__body">
					{t("QUICK_PLAY.BET_BUILDER_PICKS.PICK_NOT_AVAILABLE_MSG")}
				</div>
				<div className="popup__footer">
					<button
						onClick={() =>
							rootStore.quickPlayStore.betBuilderPicksStore.setBBPicksAvailabilityPopup(
								false
							)
						}
						type="button"
						className="popup__btn btn btn--med btn--primary--inverted"
					>
						{t("COMMON.CLOSE")}
					</button>
				</div>
			</div>
		</div>
	);
});
